const unwrapResponse = (res) => res?.data?.data ?? res?.data;

export default unwrapResponse;
